// removed by extract-text-webpack-plugin
module.exports = {"newDataForm":"styles__newDataForm___1GYQa","newDataRow":"styles__newDataRow___xG9hC","submit":"styles__submit___3fs3_","sideForm":"styles__sideForm___3Vs_V"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dataSyncTable/styles.scss
// module id = 530
// module chunks = 0